/**
 * Transforma um array de objetos em um array de opções com label e value customizáveis.
 * @param data Array de dados a ser transformado
 * @param getValue Função que retorna o value de cada item
 * @param getLabel Função que retorna o label de cada item (opcional, padrão: getValue)
 */
export function transformToOption<T>(data: T[] = [], getValue: (item: T) => unknown, getLabel: (item: T) => unknown) {
  return data.map((item) => ({
    label: String(getLabel(item)),
    value: String(getValue(item))
  }));
}
